import Application from "../../Application";
import { IApplicantService } from "../../service/applicant/ApplicantService";

export default class GetAuthorizedOperatorsInteractor {
  private application: Application;
  private applicantService: IApplicantService;

  constructor(application, applicantService) {
    this.application = application;
    this.applicantService = applicantService;
  }

  async execute(applicantReportingPeriodId: number) {
    return this.applicantService.getAuthorizedOperators(
      applicantReportingPeriodId
    );
  }
}
